import { useLinkedinRequestsByFilter } from "presentation/hooks/use-query-linkedinrequests";
import { useFilterLinkedinCardsStore } from "presentation/stores/use-filter-linkedincards-store";
import { Dropdown } from "primereact/dropdown";

const RequestLinkedinCardsDropdown: React.FC = () => {
  const { filters, setFilters } = useFilterLinkedinCardsStore();

  const { data, isLoading } = useLinkedinRequestsByFilter({
    limit: 100,
    page: 1,
    sortBy: "createdAt",
    sortOrder: "desc",
  });

  const options = (data?.data ?? []).map((request) => ({
    label: `${request.position} - ${request.city}, ${request.country}`,
    value: request.id,
  }));

  const onChange = (value: string | null) => {
    setFilters({
      ...filters,
      idRequests: { ...filters.idRequests, value: value ?? "" },
    });
  };

  return (
    <Dropdown
      value={filters.idRequests?.value || null}
      options={options}
      onChange={(event) => onChange(event.value)}
      loading={isLoading}
      placeholder="Filtrar por pesquisa"
      filter
      showClear
      className="w-full"
      style={{ minWidth: "260px" }}
    />
  );
};

export default RequestLinkedinCardsDropdown;
